import { render, staticRenderFns } from "./EditASingleSurvey.vue?vue&type=template&id=99320d94"
import script from "./EditASingleSurvey.vue?vue&type=script&lang=js"
export * from "./EditASingleSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports